import styled from 'styled-components';
import {Stack} from '@core/ui/Layout';

export const FormGroup = styled(Stack).attrs({
  direction: 'column',
})`
  margin-bottom: var(--spacing-1);
`;
